"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplementalBackgroundCheckAggregateStatus = void 0;
exports.instanceOfSupplementalBackgroundCheckAggregateStatus = instanceOfSupplementalBackgroundCheckAggregateStatus;
exports.SupplementalBackgroundCheckAggregateStatusFromJSON = SupplementalBackgroundCheckAggregateStatusFromJSON;
exports.SupplementalBackgroundCheckAggregateStatusFromJSONTyped = SupplementalBackgroundCheckAggregateStatusFromJSONTyped;
exports.SupplementalBackgroundCheckAggregateStatusToJSON = SupplementalBackgroundCheckAggregateStatusToJSON;
exports.SupplementalBackgroundCheckAggregateStatusToJSONTyped = SupplementalBackgroundCheckAggregateStatusToJSONTyped;
/**
 *
 * @export
 */
exports.SupplementalBackgroundCheckAggregateStatus = {
    None: 'NONE',
    Verified: 'VERIFIED',
    Incomplete: 'INCOMPLETE',
    Failed: 'FAILED'
};
function instanceOfSupplementalBackgroundCheckAggregateStatus(value) {
    for (const key in exports.SupplementalBackgroundCheckAggregateStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.SupplementalBackgroundCheckAggregateStatus, key)) {
            if (exports.SupplementalBackgroundCheckAggregateStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function SupplementalBackgroundCheckAggregateStatusFromJSON(json) {
    return SupplementalBackgroundCheckAggregateStatusFromJSONTyped(json, false);
}
function SupplementalBackgroundCheckAggregateStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SupplementalBackgroundCheckAggregateStatusToJSON(value) {
    return value;
}
function SupplementalBackgroundCheckAggregateStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=SupplementalBackgroundCheckAggregateStatus.js.map